var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{attrs:{"id":"user-interest"}},[_c('user-interest-articles'),_vm._v(" "),_c('div',{staticClass:"pb-4"}),_vm._v(" "),_c('user-interest-collections'),_vm._v(" "),_c('user-interest-congresses'),_vm._v(" "),_c('user-interest-journals')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }